var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.useInput,
        expression: "useInput"
      }
    ],
    ref: "textArea",
    class: _vm.classNames,
    attrs: { placeholder: _vm.placeHolder, "aria-label": _vm.ariaLabel },
    domProps: { value: _vm.useInput },
    on: {
      focus: _vm.resize,
      change: _vm.resize,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.useInput = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75c2049d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c2049d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseResizeableTextArea.vue
// module id = null
// module chunks = 